export default __webpack_public_path__ + "static/media/service-img-02.b4e0734d.png";